import {Mapper} from '@s-ui/domain'

export class FromJsonToGoogleMapsApiUrlsMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   */
  constructor({config}) {
    super()

    this._config = config
  }

  // Important: The parameter api=1 identifies the version of Maps URLs this URL is intended for. This parameter is required in every request. The only valid value is 1. If api=1 is NOT present in the URL, all parameters are ignored and the default Google Maps app will launch
  _getDirectionsUrl({encodedAddress}) {
    return `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`
  }

  _getSearchUrl({lat, lng}) {
    return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`
  }

  _getEncodedAddress({address, city, province, postalCode}) {
    const addressArray = [address, postalCode, city, province].filter(Boolean)
    const addressString = addressArray.join(' ')
    return encodeURI(addressString)
  }

  /**
   * @param {Object} rawData
   * @returns {Object}
   */
  map = rawData => {
    const {coordinates, address, city, province, postalCode} = rawData

    const encodedAddress = this._getEncodedAddress({
      address,
      city,
      province,
      postalCode
    })

    const hasCoordinates = Boolean(coordinates)

    const googleMapsApiUrls = {
      directionsUrl: this._getDirectionsUrl({encodedAddress})
    }

    if (hasCoordinates) {
      googleMapsApiUrls.searchUrl = this._getSearchUrl({coordinates})
    }

    return googleMapsApiUrls
  }
}
